import React from 'react'
import ProfileNav from './profile-nav'
import { ProfileBillingTableRow } from './profile-billing-table-row'

export const ProfileBilling = () => {
    return (

        <div>
            <ProfileNav />

            <div className='container'>
                <div className='row align-items-center justify-content-center'>
                    <div>
                        <p>Total Amount Spent</p>
                    </div>
                </div>
                <div>
                    <div className='row align-items-center
                     justify-content-center brand-yellow-border-bottom '>
                        <div className='col-md-3'>
                            Dog Name
                        </div>
                        <div className='col-md-6'>
                            Date Registered
                        </div>
                        <div className='col-md-3'>
                            Cost
                        </div>
                    </div>
                    <ProfileBillingTableRow/>
                    <ProfileBillingTableRow/>
                    <ProfileBillingTableRow/>
                    <ProfileBillingTableRow/>
                    <ProfileBillingTableRow/>
                    <ProfileBillingTableRow/>
                    <ProfileBillingTableRow/>
                    <ProfileBillingTableRow/>
                    <ProfileBillingTableRow/>

                </div>
            </div >
        </div>

    )
}